import { render, staticRenderFns } from "./GlobalNotification.vue?vue&type=template&id=07fb7736&scoped=true"
import script from "./GlobalNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalNotification.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalNotification.vue?vue&type=style&index=0&id=07fb7736&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fb7736",
  null
  
)

export default component.exports